/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_FORM_SPLIT_UTILS
 * Date:         2025-12-30
 * Modified By:  Cursor
 *
 * Description:
 * Extracted utility functions from BroadcastForm.tsx.
 */

import { BroadcastItemCreate } from "../../../../services/broadcastService";
import { Currency } from "../../../../interfaces/Currency";

export const FIELD_LABELS: Record<string, string> = {
  categories: "Categories",
  category: "Category",
  manufacturer: "Manufacturer",
  partNumber: "SKU/Model/Part Number",
  condition: "Condition",
  quantity: "Quantity",
  currency: "Currency",
  price: "Price",
  description: "Description",
  type: "Broadcast Type",
};

export const makeBlankBroadcastItem = (preferredCurrency: Currency): BroadcastItemCreate => ({
  manufacturer: "",
  partNumber: "",
  model: "",
  quantity: undefined,
  condition: "",
  price: undefined,
  currency: preferredCurrency || "USD",
  categories: undefined,
  description: "",
  categoryNeedsReview: false,
});

export const buildTouchedShape = (values: any) => {
  const items = values.broadcast ?? values.items ?? [];
  const touchedItems = items.map(() => ({
    categories: true,
    manufacturer: true,
    partNumber: true,
    condition: true,
    quantity: true,
    currency: true,
    price: true,
    description: true,
  }));

  return {
    type: true,
    broadcast: touchedItems,
    items: touchedItems,
  };
};

export const flattenErrors = (
  obj: any,
  prefix = "",
  out: Record<string, string> = {},
): Record<string, string> => {
  if (!obj || typeof obj !== "object") return out;
  for (const k of Object.keys(obj)) {
    const path = prefix ? `${prefix}.${k}` : k;
    const v = obj[k];
    if (v && typeof v === "string") out[path] = v;
    else flattenErrors(v, path, out);
  }
  return out;
};

export const summarizeByItem = (flat: Record<string, string>) => {
  const perItem: Record<number, Set<string>> = {};
  Object.keys(flat).forEach((p) => {
    const m = p.match(/^(?:broadcast|items)\.(\d+)\.([^.[\]]+)$/);
    if (!m) return;
    const idx = Number(m[1]);
    const key = m[2];
    (perItem[idx] ??= new Set()).add(FIELD_LABELS[key] ?? key);
  });
  return Object.keys(perItem)
    .map(Number)
    .sort((a, b) => a - b)
    .map((i) => `Broadcast ${i + 1}: ${Array.from(perItem[i]).join(", ")}`);
};
